import {Component, Input, OnInit, Optional, inject} from '@angular/core';
import {MessageType} from '@mpt-fo/common/shared/models/utility.model';
import {NZ_MODAL_DATA, NzModalRef} from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-message-modal',
	templateUrl: './message-modal.component.html',
	styleUrls: ['./message-modal.component.scss']
})
export class MessageModalComponent implements OnInit {
	messageType: string;
	MsgTypes = MessageType;
	description: string;
	title: string;
	useFullButton: boolean;
	forNewDevice: boolean;
	canShowCancelButton: boolean;
	buttonText: string;
	savedRes: any;
	@Input() showSuspendedCountDown: boolean;
	@Input() suspensionReleaseTime: any;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(@Optional() private modal: NzModalRef) {
	}

	ngOnInit(): void {
		this.initialize();
	}

	initialize() {
		this.modal.componentInstance = {...this.modal.componentInstance, ...this.nzModalData}
		const data = this.modal?.componentInstance?.data;
		this.description = data?.description;
		this.title = data?.title;
		this.messageType = data?.messageType;
		this.useFullButton = data?.useFullButton;
		this.forNewDevice = data?.forNewDevice;
		this.buttonText = data?.buttonText;
		this.canShowCancelButton = data?.canShowCancelButton;
		this.savedRes = data?.res;
		this.suspensionReleaseTime = data?.suspensionReleaseTime;
		this.showSuspendedCountDown = data?.showSuspendedCountDown;
	}

	continue(msg: MessageType, res?) {
		this.modal?.componentInstance.callback({messageType: msg, res});
	}

	closeModal() {
		this.modal.componentInstance.callback();
		// this.modal.destroy();
	}

}
